import React from "react";
import { Link } from "react-router-dom";

const Projects = ()=>{
    return (
        <div className="projects">
            <h1>Projects</h1>
            <ul>
                <li>
                    <Link to="">product delivery</Link>
                </li>
            </ul>
        </div>
    )
}

export default Projects;